import { Checkbox } from '@eventbrite/marmalade';
import React from 'react';
import {
    constructFilterItemKey,
    FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP,
    FilterItem,
    FilterProps,
    FilterSection,
    RadioType,
    SUBLOCALITY_FILTER,
} from '../../../../';
import { useIsInSublocalityExperiment } from './hooks';

export const SublocalityFilters: React.FunctionComponent<FilterProps> = (
    props,
) => {
    const { isSublocalityFilterExperiment, parentLocation } =
        useIsInSublocalityExperiment(props.locationSlug);

    if (!isSublocalityFilterExperiment || !parentLocation) {
        return null;
    }

    return (
        <FilterSection
            filters={parentLocation.sublocalities}
            onOptionChange={(value: string[]) => {
                props.onFilterChange?.(SUBLOCALITY_FILTER, value);
            }}
            title={
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[SUBLOCALITY_FILTER]
                    .label
            }
            activeFilterOption={props.selectedFilters?.[SUBLOCALITY_FILTER]}
            shouldScrollIntoView={props.filterTypeToShow === SUBLOCALITY_FILTER}
            defaultActiveFilterOption={[]}
            isMobile={props.isMobile}
        >
            {(filterItem: RadioType) => {
                return (
                    <FilterItem
                        ChoiceComponent={Checkbox}
                        key={constructFilterItemKey(
                            'sublocalities',
                            filterItem.value,
                            props.isMobile,
                        )}
                        value={filterItem.value}
                        display={filterItem.display}
                    />
                );
            }}
        </FilterSection>
    );
};
